export default {
    cptDataForm: {
        dataText: '{"value":[]}',
        dataSource: 1,
        pollTime: 0,
        apiUrl: '/text',
        sql: 'select id from test limit 1'
    },
    attribute:{
        cptTableData: [{ "name": "值", "value": "", "namekey": "value" }],
        top:"10",
        bottom:"10",
        left:"10",
        right:"10",
        bgColor:'#00000000',
        textColor:'#ffffff',
        fontStyle:'normal',
        fontWeight:'normal',
        fontFamily:'微软雅黑',
        fontSize:12,
        borderSize:0,
        borderColor:'#333333',
        borderRadius:0,
        lineType:'solid',
        activeBgColor: '#3F99FB',
        activeBrColor:'#3F99FB',
        activeColor: '#fff',
    },
    interaction:{ intType: 'none'}
}